export const MOONGATE_TERMS_URL =
  "https://themoongate.notion.site/Moongate-Terms-and-Conditions-3f98c36fff344ba2811a7bc17b5d2056";

export const MOONGATE_PRIVACY_URL =
  "https://themoongate.notion.site/Moongate-Privacy-f4f35ff31d98430680b5453441dc3d18";

export const MOONGATE_TERMS_SALE_URL =
  "https://themoongate.notion.site/Moongate-Terms-of-Sale-00f0e9cce59b4eedb1389b059b2ce988";
